export const scores = [0,1,2,3,4,5,6,7,8,9,10];
export const lowest = "0 - Not at all likely";
export const highest ="10 - Extremely likely";

